import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/return-policy/page.tsx");
